import { FORM_BUNDLES_AFTER_SUBMIT_ACTION_TYPE } from '../actions';

const initialState = {};

const formBundlesAfterSubmitSchemaReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FORM_BUNDLES_AFTER_SUBMIT_ACTION_TYPE.GET_CRITERIA_SCHEMA:
      return payload || initialState;

    default:
      return state;
  }
};

export default formBundlesAfterSubmitSchemaReducer;
